import { Box, Link, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { TokenDowngrader } from "./TokenDowngraderModal";
import { TokenUpgrader } from "./TokenUpgraderModal";
import analyticsInstance from "../../config/analytics";
import { getSupportedTokens } from "../../config/tokens";
import { fetchBalances } from "../../helpers/balances";
import { useSupportedNetwork } from "../../helpers/hooks/network";
import { formatEther, formatUnits } from "ethers/lib/utils";
import { formatToDisplay } from "../../helpers/numbers";
import { getExplorerAddressLink } from "../../config/resolver";
import { useProvider } from "wagmi";

function Holdings({ account }) {
  const [tokensBals, setTokensBals] = useState();
  const [refetch, setRefetch] = useState();

  const provider = useProvider();
  const { isSupportedNetwork, chain } = useSupportedNetwork();

  useEffect(() => {
    if (chain && (refetch || (isSupportedNetwork && account))) {
      setTokensBals(null);
      const tokens = getSupportedTokens(chain.id);

      fetchBalances(provider, account, tokens)
        .then(setTokensBals)
        .catch((e) => {
          // TODO: error handling
          console.log("error fetching holdings", e);

          analyticsInstance.track("HoldingsGetError", {
            account: account,
            tokens: tokens,
            error: e,
          });
        })
        .finally(() => {
          setRefetch(null);
        });
    } else {
      setTokensBals([]);
    }
  }, [account, provider, isSupportedNetwork, chain, refetch]);

  return (
    <Box py="2em">
      <Text fontSize="xl" fontWeight="bold" mb="0.5em">
        🛍️ Holdings
      </Text>

      {tokensBals ? (
        <>
          {tokensBals.length > 0 ? (
            <TableContainer>
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th colSpan={3}>ERC20</Th>
                    <Th colSpan={3}>SuperToken</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {tokensBals.map((t, idx) => {
                    return (
                      <Tr key={idx}>
                        <Td isNumeric>{formatToDisplay(formatUnits(t.erc20Balance, t.erc20Decimals))}</Td>
                        <Td>
                          <Link
                            href={getExplorerAddressLink(chain, t.erc20Address)}
                            onClick={() => analyticsInstance.track("ExplorerLinkClicked")}
                            isExternal
                          >
                            {t.erc20Symbol}
                          </Link>
                        </Td>

                        <Td>
                          {t.erc20Balance > 0 && (
                            <TokenUpgrader size="xs" account={account} tokenBalance={t} setRefetch={setRefetch} />
                          )}
                        </Td>

                        <Td isNumeric>{formatToDisplay(formatEther(t.tokenxBalance))}</Td>
                        <Td>
                          <Link
                            href={getExplorerAddressLink(chain, t.tokenxAddress)}
                            onClick={() => analyticsInstance.track("ExplorerLinkClicked")}
                            isExternal
                          >
                            {t.tokenxSymbol}
                          </Link>
                        </Td>
                        <Td>
                          {t.tokenxBalance > 0 && (
                            <TokenDowngrader account={account} tokenBalance={t} setRefetch={setRefetch} />
                          )}
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text>No tokens to display. Are you connected and on the right network?</Text>
          )}
        </>
      ) : (
        <Spinner />
      )}
    </Box>
  );
}

export default Holdings;
